import { DeliveryUnit } from 'core/channelGroup/ChannelGroup';
import { ChannelGroupSetting } from 'core/channelGroup/ChannelGroupSettings';

/**
 * Per-channel-group campaign limitation feature keys.
 *
 * These are the bare feature keys (without the
 * `campaign_channel_${channelGroupId}_` scope prefix). To build the scoped
 * add-on key consumed by `AddonFeatureManager.isFeatureEnable`, prefix each key
 * with `campaign_channel_${channelGroupId}_` — i.e. the scoped key format is
 * `campaign_channel_${channelGroupId}_${featureKey}`, and the form data is the
 * flat key `campaignLimitation[`channel_${channelGroupId}_${featureKey}`]`.
 */

// RTB (channel group id 0)
export const RTB_CAMPAIGN_LIMITATION_KEYS: string[] = [
  'country',
  'city',
  'spaceType',
  'device',
  'target_audience',
  'adexchange',
  'asiamax_space',
  'domain',
  'space_category',
  'tenmax_audience',
  'gender',
  'age',
  'carrier',
  'enablePMPDeal',
  'testMode',
  'keyword',
  'content_language',
  'content_category'
];

// Outdoor + DeliveryUnit.STORE
export const OUTDOOR_STORE_CAMPAIGN_LIMITATION_KEYS: string[] = [
  'outdoorPlaceCategories',
  'cityGroup',
  'administrativeArea',
  'storeNum',
  'systemRecommendOutdoorDevice',
  'testMode'
];

// Outdoor + DeliveryUnit.DEVICE
export const OUTDOOR_DEVICE_CAMPAIGN_LIMITATION_KEYS: string[] = [
  'outdoorPlaceCategories',
  'cityGroup',
  'administrativeArea',
  'deviceCharacteristic',
  'systemRecommendOutdoorDevice',
  'testMode'
];

/**
 * Resolve the campaign limitation add-on feature keys for a given channel
 * group. Returns the bare feature keys (no scope prefix).
 */
export const getCampaignLimitationAddonKeys = (
  channelGroupSetting: ChannelGroupSetting
): string[] => {
  if (channelGroupSetting.isOutdoorChannel()) {
    return channelGroupSetting.config.deliveryUnit === DeliveryUnit.STORE
      ? OUTDOOR_STORE_CAMPAIGN_LIMITATION_KEYS
      : OUTDOOR_DEVICE_CAMPAIGN_LIMITATION_KEYS;
  }
  return RTB_CAMPAIGN_LIMITATION_KEYS;
};
